<template>
    <div>
        <el-form  :model="formData" :style="{height: tableHeight+'px',overflowY:'auto'}" :inline="true" ref="formRef" label-width="110px" size="mini">
            <el-form-item  prop="purchaseNo" label="采购订单编号">{{formData.purchaseNo}}</el-form-item>
            <el-form-item  prop="no" label="设备编码">{{formData.no}}</el-form-item>

<!--            <el-form-item  prop="typeStr" label="类型">{{formData.typeStr}}</el-form-item>-->
            <el-form-item  prop="vc_pzname" label="品种">{{formData.pzname}}</el-form-item>
<!--            <el-form-item  prop="i_state" label="状态">-->
<!--                <el-select v-model="formData.i_state" size="mini" >-->
<!--                    <el-option v-for="item in i_stateList" :key="item.id" :label="item.name" :value="item.id"></el-option>-->
<!--                </el-select>-->
<!--            </el-form-item>-->
            <el-form-item  prop="stateStr" label="状态">{{formData.stateStr}}</el-form-item>
            <el-form-item  prop="gdname" label="工段部分">{{formData.gdname}}</el-form-item>
            <el-form-item  prop="bmname" label="车间部门">{{formData.bmname}}</el-form-item>
            <el-form-item  prop="mtstate" label="维修状态">{{formData.mtstateStr}}
<!--                <el-select v-model="" size="mini" >-->
<!--                    <el-option v-for="item in i_mtstateList" :key="item.id" :label="item.name" :value="item.id"></el-option>-->
<!--                </el-select>-->
            </el-form-item>
<!--            <el-form-item  prop="i_ctype" label="设备类型">-->
<!--                <el-select v-model="formData.i_ctype" size="mini" >-->
<!--                    <el-option v-for="item in i_ctypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>-->
<!--                </el-select>-->
<!--            </el-form-item>-->
            <el-form-item  prop="ctypeStr" label="类型">{{formData.ctypeStr}}</el-form-item>
            <el-form-item  prop="name" label="设备名">
                <el-input v-model="formData.name"  size="mini" :class="different.includes('name')?'borderred':''" ></el-input>
            </el-form-item>
            <el-form-item  prop="i_type" label="设备类型">
                <el-select v-model="formData.i_type" size="mini" :class="different.includes('i_type')?'borderred':''">
                    <el-option v-for="item in i_typeList" :key="item.ywid" :label="item.name" :value="item.ywid" ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item  prop="ggxh" label="规格型号">
                <el-input v-model="formData.ggxh"  size="mini" class="input" :class="different.includes('ggxh')?'borderred':''"></el-input>
            </el-form-item>
            <el-form-item  prop="pay" label="采购金额">
                <el-input-number :min="0" :controls="false" v-model="formData.pay"  size="mini" class="input" :class="different.includes('pay')?'borderred':''"></el-input-number>
            </el-form-item>
            <el-form-item  prop="principal" label="负责人">
                <el-select multiple v-model="principal" size="mini" :class="different.includes('principal')?'borderred':''">
                    <el-option v-for="item in principalList" :key="item.i_id.toString()" :label="item.vc_name" :value="item.i_id.toString()"></el-option>
                </el-select>
<!--                <el-input v-model="formData.principal"  size="mini" class="input" ></el-input>-->
            </el-form-item>
            <el-form-item  prop="gykhname" label="供应客户">
                <el-input v-model="formData.gykhname"  size="mini" class="input" :class="different.includes('gykhname')?'borderred':''"></el-input>
            </el-form-item>
            <el-form-item  prop="buytime" label="购买时间">
                <el-date-picker size="mini" v-model="formData.buytime" :class="different.includes('buytime')?'borderred':''" formt="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" placeholder="选择日期">
                </el-date-picker>
<!--                <el-input v-model="formData.buytime"  size="mini" class="input" ></el-input>-->
            </el-form-item>
            <el-form-item  prop="tarno" label="设备位号">
                <el-input v-model="formData.tarno"  size="mini" class="input" :class="different.includes('tarno')?'borderred':''"></el-input>
            </el-form-item>
            <el-form-item  prop="process" label="工序位置">
                <el-input v-model="formData.process"  size="mini" class="input" :class="different.includes('process')?'borderred':''"></el-input>
            </el-form-item>
            <el-form-item  prop="productNo" label="产品编号">
                <el-input v-model="formData.productNo"  size="mini" class="input" :class="different.includes('productNo')?'borderred':''"></el-input>
            </el-form-item>
            <el-form-item  prop="cjnote" label="厂家备注">
                <el-input v-model="formData.cjnote"  size="mini" class="input" :class="different.includes('cjnote')?'borderred':''"></el-input>
            </el-form-item>
            <el-form-item  prop="htcj" label="合同厂家">
                <el-input v-model="formData.htcj"  size="mini" class="input" :class="different.includes('htcj')?'borderred':''"></el-input>
            </el-form-item>
            <el-form-item  prop="zzcj" label="制造厂家">
                <el-input v-model="formData.zzcj"  size="mini" class="input" :class="different.includes('zzcj')?'borderred':''"></el-input>
            </el-form-item>
            <el-form-item  prop="azcj" label="安装厂家">
                <el-input v-model="formData.azcj"  size="mini" class="input" :class="different.includes('azcj')?'borderred':''"></el-input>
            </el-form-item>
            <el-form-item  prop="wbcj" label="维保厂家">
                <el-input v-model="formData.wbcj"  size="mini" class="input" :class="different.includes('wbcj')?'borderred':''" ></el-input>
            </el-form-item>
            <el-form-item  prop="startDate" label="启用日期">
                <el-date-picker size="mini" v-model="formData.startDate" :class="different.includes('startDate')?'borderred':''" formt="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" placeholder="选择日期">
                </el-date-picker>
<!--                <el-input v-model="formData.startDate"  size="mini" class="input" ></el-input>-->
            </el-form-item>
            <el-form-item  prop="designedLife" label="设计寿命(年)">
                <el-input v-model="formData.designedLife"  size="mini" :class="different.includes('designedLife')?'borderred':''" class="input" ></el-input>
            </el-form-item>
            <el-form-item  prop="repairCycle" label="检修周期(月)">
                <el-input v-model="formData.repairCycle"  size="mini" :class="different.includes('repairCycle')?'borderred':''" class="input" ></el-input>
            </el-form-item>
            <el-form-item  prop="nextrepairDate" label="下次检修日期">
                <el-date-picker size="mini" v-model="formData.nextrepairDate" :class="different.includes('nextrepairDate')?'borderred':''" formt="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" placeholder="选择日期">
                </el-date-picker>
<!--                <el-input v-model="formData.nextrepaireDate"  size="mini" class="input" ></el-input>-->
            </el-form-item>
            <el-form-item  prop="checkCycle" label="检验周期(月)">
                <el-input v-model="formData.checkCycle" :class="different.includes('checkCycle')?'borderred':''" size="mini"></el-input>
            </el-form-item>
            <el-form-item  prop="nextcheckDate" label="下次检验日期">
                <el-date-picker size="mini" v-model="formData.nextcheckDate" :class="different.includes('nextcheckDate')?'borderred':''" formt="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" placeholder="选择日期">
                </el-date-picker>
<!--                <el-input v-model="formData.nextcheckDate"  size="mini" class="input" ></el-input>-->
            </el-form-item>
            <el-form-item  prop="bfDate" label="报废日期">
                <el-date-picker size="mini" v-model="formData.bfDate" :class="different.includes('bfDate')?'borderred':''" formt="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" placeholder="选择日期">
                </el-date-picker>
<!--                <el-input v-model="formData.bfdate"  size="mini" class="input" ></el-input>-->
            </el-form-item>
<!--            <el-form-item  label="图片" prop="files" >-->
<!--                    <div v-if="formData.files&&formData.files.otherfiles">-->
<!--                        <div style="width: 150px;max-heigth:150px;display: inline-block;position: relative;padding-right: 10px" v-for="(p,i) in formData.files.otherfiles">-->
<!--                            <el-image class="img" :src="file_root+'/'+p.vc_path" :preview-src-list="[file_root+'/'+p.vc_path]"></el-image>-->
<!--                            <i class="el-icon-error" style="position: absolute;right:0;top:-8px;" @click="removefile(i)" ></i>-->

<!--                        </div>-->
<!--                    </div>-->
<!--                    <el-button  style="position: relative">上传附件<input type="file" name="files" value="" id="uploadfile"-->
<!--                                              ref="uploadclear1"    class="upload-input uploadfile1" @change="uploadFile" ></el-button>-->
<!--                </el-form-item >-->
            <hr/>
            <div style="display: inline-block" v-for="(item,index) in dataList">
                <el-form-item  :prop="item.prop" :label="item.label">
                    <el-input v-model="formData[item.prop]"  size="mini" class="input" :disabled="item.disabled"></el-input>
                </el-form-item>
            </div>

            <div class="formDiv flex jcsb">
                <el-form-item class="form-title" prop="lruname" label="录入人" >
                    <span>{{formData.lruname}}</span>
                </el-form-item>
                <el-form-item class="form-title" prop="createtime" label="录入日期" >
                    <span>{{formData.createtime}}</span>
                </el-form-item>
            </div>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: center">
            <template >
                <el-button type="primary" @click="saveForm" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="canEdit">保存</el-button>
<!--                <el-button type="primary" @click="editForm" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="!canEdit">编辑</el-button>-->
            </template>
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>

        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp,baseApp,file_url,baseVersion,file_root} from "@/utils/baseUrl";

    export default {
        name: "DetailPage",
        components: {},
        props:{
            data:{
                type:Array,
                required:true
            }
        },
        data() {
            return {
                tableHeight:0,
                canEdit:true,
                 disabled:false,
                baseerp:'',
                file_root:'',
                formData:{},
                i_id:0,
                i_typeList:[
                    // {id:1,name:'设备'},{id:2,name:'备品备件'}
                    ],
                i_ctypeList:[{id:1,name:'设备'},{id:2,name:'设备配件'}],
                i_mtstateList:[{id:1,name:'良好'},{id:2,name:'维修中'}],
                i_stateList:[
                    // {id:0,name:'未启用'},{id:1,name:'调试中'},{id:2,name:'运行中'},{id:-1,name:'已停机'},{id:-2,name:'已停用'}
                    ],
                i_type:'',
                i_ctype:'',
                principalList:[],
                principal:[],
                dataList:[],
                different:[],//主属性不一样
            }
        },
        watch: {
            data: {
                handler() {

                },
                immediate: true,
                deep: true
            },
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted() {
            this.ids=this.data.map(a=>a.i_id);
            // this.ids=[34];
            this.i_type=this.data[0].i_type;
            this.i_ctype=this.data[0].i_ctype;
            // this.i_type=1;
            // this.i_ctype=1;
            this.getConfigColumn();
            this.baseerp=baseerp;
            this.file_root=file_root;
            this.getDateYYYYMMddHHMMSS();

            this.formData.lruname=sessionStorage.getItem("lruname");
            this.formData.i_lruid=sessionStorage.getItem("userid");
            this.$nextTick(()=>{
                this.onResize();

            })
        },
        methods: {
            onResize (n){
                if (n==undefined) n=this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h;
                if(this.tableHeight<60)this.tableHeight=60;
            },

            saveForm(){
                let form={}
                this.formData.principal=this.principal.join();
                for(let i in this.formData){
                    let m=this.formData[i];
                    for(let j in this.fData){
                        let n=this.fData[j];
                        if(i==j&&m!=n){
                            // console.log(m,n)
                            if(i=='files'){
                                form[i]=JSON.stringify(m)

                            }else{
                                form[i]=m

                            }
                        }
                    }
                }
                // console.log(form,'form')
                this.updateDeviceLedger(form)
                this.disabled=true
            },

            cancel(){
                this.$emit('close')
            },
            async getDeviceDict(type,val){
                let param={
                    type:val,
                };
                let res=await API.getDeviceDict(param);
                if ( res.code == 1 ){
                    if(type=='type'){
                        this.i_typeList=res.data
                    }else if(type=='state'){
                        this.i_stateList=res.data
                    }
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async getPrincipalList(){
                let param={

                };
                let res=await API.getPrincipalList(param);
                if ( res.code == 1 ){
                    this.principalList=res.data
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async getConfigColumn(){
                this.dataList=[]
                let param={
                    type:this.i_type,
                    ctype:this.i_ctype,
                };
                let res=await API.getConfigColumn(param);
                if ( res.code == 1 ){
                    for(let i in res.data){
                        let n={'label':res.data[i],'prop':i,'disabled':false}
                        this.dataList.push(n)
                    }
                    this.getDeviceLedgerDetail();
                    this.getPrincipalList();
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async getDeviceLedgerDetail(){
                let param={
                    ids:this.ids
                };
                let res=await API.getDeviceLedgerDetail(param);
                if ( res.code == 1 ){
                    this.fData=JSON.parse(JSON.stringify(res.data[0]));
                    this.formData=JSON.parse(JSON.stringify(res.data[0]));
                    this.resList=res.data
                    this.different=[]
                    for(let i=1;i<this.resList.length;i++) {
                        let r=this.resList[i]
                        for (let D in this.formData){
                            if (!this.different.includes(D)){
                                if(r[D]!=this.formData[D]){
                                    // console.log(r[D],'--',D,'--',this.formData[D])
                                    this.different.push(D)
                                }
                            }

                        }
                    }
                    // console.log(this.different,'this.different')
                        // this.i_id=res.data.i_id;
                    for(let i=0;i<this.dataList.length;i++){
                        let d=this.dataList[i],
                            prop=d.prop;
                        for(let j=0;j<res.data.length;j++){
                            let r=res.data[j];
                            if(j+1<res.data.length){
                                if(r[prop]!==res.data[j+1][prop]){
                                    this.dataList[i].disabled=true
                                    break
                                }
                            }
                        }
                    }
                    this.$forceUpdate()
                    // console.log(this.dataList,'this.dataList')
                    // console.log(this.dataList,'this.dataList')
                    if(this.formData.files)this.formData.files= JSON.parse(this.formData.files)
                    // console.log(this.formData.files)
                    this.principal=this.formData.principal?this.formData.principal.split(','):[];
                    this.i_type=this.formData.i_type;
                    this.i_ctype=this.formData.i_ctype;

                    if(this.i_ctype==1){
                        this.getDeviceDict('type',7);
                        this.getDeviceDict('state',9);

                    }else if(this.i_ctype==2){
                        this.getDeviceDict('type',8);
                        this.getDeviceDict('state',10);
                    }
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async updateDeviceLedger(val){
                let form=val;
                form.ids=this.ids;
                let param=form;
                // console.log('param',param)
                // return
                let res=await API.updateDeviceLedger(param);
                if ( res.code == 1 ){
                    this.$emit('close','save');
                    this.disabled=false

                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                    this.disabled=false


                }
            },
            async uploadFile(e) {
                let that = this;
                let i = 0;
                let $files = e.target.files[0];
                let fileName = $files.name;
                let type = $files.type;
                var list = {
                    "image/jpeg": true,
                    "image/png": true,
                    "image/jpg": true,
                    "image/bmp": true,
                    "application/pdf": true
                };
                let result = list[type];
                // if(($files && result==false) || ($files &&result==undefined)){
                //     that.$message.error('请上传格式正确的文件');
                //     return;
                // };
                if ($files) {
                    that.fileName = $files.name;
                    that.fileType = $files.type;
                    that.fileUrl = window.URL.createObjectURL(e.target.files[0]);
                } else {
                    that.fileName = "";
                    that.fileType = "";
                    that.fileUrl = "";
                }
                if (that.fileName) {
                    var fileId = 'uploadfile' + that.idNum;
                    var param = {
                        // "file": fileId,
                        // "fileName": that.fileName,
                        // "IDtype": "",
                        // "type": 1,
                        "style": "device",
                        "files": $files,
                        //"token":sessionStorage.getItem("token"),
                        //"app": "dsmanage",
                        "vc_app": this.baseerp+"device",
                        "i_appid": 0,
                        // "version": "1.0",
                        // "i_uid": sessionStorage.getItem("userid"),
                        "vc_lruname":  sessionStorage.getItem("lruname"),
                        "i_lruid": sessionStorage.getItem("userid"),
                        // "i_mid": this.mid
                    };
                    let FD = new FormData();
                    for (let key in param) {
                        FD.append(key, param[key])
                    }
                    let res = await API.uploadFile(param);
                    if (res.code == 1) {
                        // this.filesImgList.push(res.data[0])
                        // this.filesList.push(res.data[0].i_id)
                        let file={
                            i_id:res.data[0].i_id,
                            vc_name:res.data[0].filename,
                            vc_newname:res.data[0].filenewname,
                            vc_path:res.data[0].vc_path
                        }
                        if(this.formData.files==''){
                            this.formData.files={
                                signfile:{},
                                otherfiles:[]
                            }
                        }
                        // this.formData.files.otherfiles=this.formData.files.otherfiles?this.formData.files.otherfiles:[]
                        this.formData.files.otherfiles.push(file)
                        this.$forceUpdate()

                        // console.log('this.formData.files=',this.formData.files)
                    } else if (res.code == -2) {
                        this.$router.push('/login');
                        this.$message.error(res.message);
                    } else {
                        this.$message.error(res.message);
                    }
                }
            },
            removefile(i){
                this.formData.files.otherfiles.splice(i,1)
            },
            //获取当天日期
            getDateYYYYMMddHHMMSS(){
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const strDate = date.getDate().toString().padStart(2, '0');
                this.formData.createtime=`${date.getFullYear()}-${month}-${strDate}`;
            },
        },
    }
</script>

<style lang="scss" scoped>
    .flex{
        display:flex;
    }
    /deep/.borderred .el-input__inner{
        border-color: red ;
    }
    .jcsb{
        justify-content: space-between;

    }
    .el-form-item__content .el-input,.el-form-item__content .el-input-number,.el-form-item__content .el-select{
        width: 150px;
    }
    .uploadfile1{
        position: absolute;
        opacity: 0;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
    }
</style>